import React from "react";
import "../components.scss";
const Popover = ({ content }) => {
  return (
    <div className="custom-popover">
      <div className="content">{content}</div>
    </div>
  );
};

export default Popover;
